// Path: ./src/app/components/PermissionSelectTable/index.tsx
import { Checkbox, FormControlLabel } from "@mui/material";
import React from "react";
import {
  TableList,
  InputTextField,
  Wrapper,
  Table,
  TableHead,
  TableBody,
} from "./styled";

interface Props {
  title: string;
  isChecked: boolean;
  handleChange: () => void;
  dataTestId?: string;
  itemsList: {
    isChecked: boolean;
    title: string;
    includeTextInput?: boolean;
    /**
     * Click event handler for a permission checkbox that allows selecting or unselecting the permission.
     */
    onClick?: () => void;
    dataTestId?: string;
  }[];
}
export const PermissionSelectTable = ({
  isChecked,
  itemsList,
  handleChange,
  title,
  dataTestId,
}: Props) => {
  const withInputField = itemsList?.find((val) => val.includeTextInput);
  return (
    <Wrapper data-testid="permissionselecttable-test-id">
      <Table withInputField={withInputField}>
        <TableHead>
          <FormControlLabel
            sx={{ fontWeight: 700 }}
            control={
              <Checkbox
                checked={isChecked}
                onChange={handleChange}
                data-testid={dataTestId}
                sx={{
                  color: "#f58220",
                  "&.Mui-checked": {
                    color: "#f58220",
                  },
                }}
              />
            }
            label={title}
          />
        </TableHead>
        <TableBody>
          {itemsList?.map((value) => {
            return (
              <TableList
                key={value.title}
                data-testid="permissionselecttable-test-id"
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={isChecked ? false : true}
                      checked={value.isChecked}
                      onClick={value.onClick}
                      inputProps={{ "aria-label": "controlled" }}
                      sx={{
                        color: "#f58220",
                        "&.Mui-checked": {
                          color: isChecked ? "#f58220" : "#808080",
                        },
                      }}
                      data-testid={value?.dataTestId}
                    />
                  }
                  label={value.title}
                />
                {value?.includeTextInput && <InputTextField />}
              </TableList>
            );
          })}
        </TableBody>
      </Table>
    </Wrapper>
  );
};
